import { ReactNode } from 'react';

interface AppContentProps {
  children: ReactNode;
}

export function AppContent({ children }: AppContentProps) {
  return (
    <main className="flex-1 overflow-y-auto bg-background transition-colors">
      <div className="container mx-auto px-4 py-2">{children}</div>
    </main>
  );
}
